import React, { createContext, useContext, useState, useEffect } from 'react';
import { settingsApi } from '../services/api';
import { useAuth } from './AuthContext';

const SettingsContext = createContext(null);

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) throw new Error('useSettings must be used within a SettingsProvider');
  return context;
};

export const SettingsProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [settings, setSettings] = useState({ default_email: '', show_211: false });

  useEffect(() => {
    if (!isAuthenticated) {
      setSettings({ default_email: '', show_211: false });
      return;
    }
    settingsApi.get()
      .then(res => setSettings(res.data))
      .catch(() => {});
  }, [isAuthenticated]);

  const refreshSettings = async () => {
    try {
      const res = await settingsApi.get();
      setSettings(res.data);
    } catch {}
  };

  return (
    <SettingsContext.Provider value={{ settings, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext;
